export default __webpack_public_path__ + "static/media/apple_watch_5.d51a3e7e.png";